import { apiSlice } from 'api/apiSlice'
import { Currency } from 'shared/types'

const currencyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrencies: builder.query<{ currencies: Currency[] }, void>({
      query: () => ({
        app: 'sneakers',
        method: 'GET',
        url: `/web-api/v1/currencies`,
      }),
    }),
    setCurrency: builder.mutation<{ success: boolean }, string>({
      query: (currencyISOCode) => ({
        app: 'sneakers',
        data: { currency: currencyISOCode },
        method: 'PUT',
        url: `/web-api/v1/currencies/set_preferred_currency`,
      }),
    }),
  }),
})

export const { useGetCurrenciesQuery, useSetCurrencyMutation } = currencyApi
